import { Component, StrictMode, type ErrorInfo, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import AdminApp from "./AdminApp";
import OrderApp from "./OrderApp";
import "./styles.css";

const isAdmin = window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/");

class AppErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("app_render_failed", error, info.componentStack);
  }

  render() {
    if (this.state.failed) return <main className="fatal-error"><img className="fatal-error__logo" src="/komugiya-logo.png" alt="komugiya ナカシマ"/><h1>画面を読み込めませんでした</h1><p>通信状態を確認して、もう一度お試しください。</p><button className="button" type="button" onClick={() => window.location.reload()}>もう一度読み込む</button></main>;
    return this.props.children;
  }
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").then((registration) => registration.update()).catch(() => undefined);
  }, { once: true });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode><AppErrorBoundary>{isAdmin ? <AdminApp/> : <OrderApp/>}</AppErrorBoundary></StrictMode>,
);
